import { Observable } from 'rxjs';
import { PaginatedResults } from './paginated-results';

export interface IQuery {
  filter: IQueryLogic;
  index: number;
  size: number;
  sort?: IQuerySort;
}

export interface IQueryLogic {
  logic: 'and' | 'or';
  filters: IQueryFilter[];
}
export interface IQueryFilter {
  field: string;
  op: IQueryOperator;
  value: unknown;
}

export interface IQueryFilterOption {
  label: string;
  value: unknown;
}

export type IQueryOperator =
  '=' |
  '>' |
  '>=' |
  '<' |
  '<=' |
  'contains' |
  'startsWith' |
  'endsWith' |
  'between' |
  'in' |
  'isNull' |
  'isNotNull';

export interface IQuerySort {
  field: string;
  direction: 'asc' | 'desc';
}

export const createQuery = (init?: Partial<IQuery>): IQuery => ({
  ...{
    filter: {
      filters: [],
      logic: 'and'
    },
    index: 0,
    size: 50,
  }, ...init
});


export const queryToStr = (query: IQuery): string => btoa(JSON.stringify(query));

export const strToQuery = (query: string): IQuery => {
  const json = atob(query);
  const obj = JSON.parse(json);
  return obj;
};


export interface IQueryable<T> {
  getByQuery(query?: IQuery): Observable<PaginatedResults<T>>;
}
